<ng-container *ngIf="isOpen">
  <div class="add-cost-container">
  <div #modalbackground class="background-add-cost" (click)="close($event)"></div>
   
    
  
<div class="window-add-cost">
  <div class="cssload-container" *ngIf="isLoading">
    <div class="cssload-speeding-wheel"></div>
  </div>

  <div class="title-row">
    <div class="title">{{ 'ADD_COST.ADD_PROJECT_COST' | translate }}</div>
    <div class="counter-mobile">
      <div
        class="control"
        tabindex="0"
        role="button"
        enterPress="onCounterDown()"
        (keydown.enter)="onCounterDown()"
        (click)="onCounterDown()"
      >
        -
      </div>
      <div class="value">
        {{ itemCounter }}
      </div>
      <div
        class="control"
        tabindex="0"
        role="button"
        enterPress="onCounterUp()"
        (keydown.enter)="onCounterUp()"
        (click)="onCounterUp()"
      >
        +
      </div>
    </div>
  </div>

  <div class="content-row">
    <div class="file-section-mobile" [class.disabled]="itemCounter > 1">
      <div class="section-content">
        <div class="bills-clmn column">
          <div class="file-header">
            <input
              hidden
              type="file"
              multiple
              accept=".pdf, .jpg, .jpeg, .heic, .png"
              #uploaderInvoice
              (change)="attachFiles($event, 'invoice')"
            />
            <div class="add-btn">
              <img
                src="assets/plus-in-circle-purple.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderInvoice.click()"
                (keydown.enter)="uploaderInvoice.click()"
                (click)="uploaderInvoice.click()"
                *ngIf="files.invoiceFiles.length < 3 && itemCounter === 1"
              />
            </div>
            <div class="label">
              {{ 'ADD_COST.BILLS' | translate }}
              {{ files.invoiceFiles.length }}/3
            </div>
          </div>
          <!-- <div class="take-a-photo" *ngIf="files.invoiceFiles.length < 3">
            <img
              src="assets/camera-plus.svg"
              tabindex="0"
              role="button"
              enterPress="uploaderInvoice.click()"
              (keydown.enter)="uploaderInvoice.click()"
              (click)="uploaderInvoice.click()"
              *ngIf="files.invoiceFiles.length < 3 && itemCounter === 1"
            />
            <label for="takePhotoInvoice" class="custom-button"
              >Take a Photo</label
            >
            <input
              id="takePhotoInvoice"
              type="file"
              accept="image/*"
              capture="environment"
              hidden
              (change)="onPhotoInvoice($event)"
            />
          </div> -->
          <div
            class="file"
            *ngFor="let invoiceFile of files.invoiceFiles; let i = index"
          >
            <img src="assets/document-icon-blue.svg" />
            <div class="label">
              {{ invoiceFile.name }}
            </div>
            <div class="delete-icon">
              <img
                src="assets/cross-in-circle-red-small.svg"
                tabindex="0"
                role="button"
                enterPress="removeFile(invoiceFile, 'invoice', i)"
                (keydown.enter)="removeFile(invoiceFile, 'invoice', i)"
                (click)="removeFile(invoiceFile, 'invoice', i)"
                *ngIf="itemCounter === 1"
              />
            </div>
          </div>
        </div>
        <div class="payment-clmn column">
          <div class="file-header">
            <input
              hidden
              type="file"
              multiple
              accept=".pdf, .jpg, .jpeg, .heic, .png"
              #uploaderPayment
              (change)="attachFiles($event, 'payment')"
            />
            <div class="add-btn">
              <img
                src="assets/plus-in-circle-purple.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderPayment.click()"
                (keydown.enter)="uploaderPayment.click()"
                (click)="uploaderPayment.click()"
                *ngIf="files.paymentFiles.length < 3 && itemCounter === 1"
              />
            </div>
            <div class="label">
              {{ 'ADD_COST.PAYMENT_STATEMENT' | translate }}
              {{ files.paymentFiles.length }}/3
            </div>
          </div>
          <!-- <div class="take-a-photo" *ngIf="files.paymentFiles.length < 3">
            <img
              src="assets/camera-plus.svg"
              tabindex="0"
              role="button"
              enterPress="uploaderInvoice.click()"
              (keydown.enter)="uploaderInvoice.click()"
              (click)="uploaderInvoice.click()"
              *ngIf="files.paymentFiles.length < 3 && itemCounter === 1"
            />
            <label for="takePhoto" class="custom-button">Take a Photo</label>
            <input
              id="takePhoto"
              type="file"
              accept="image/*"
              capture="environment"
              hidden
              (change)="onPhotoPayment($event)"
            />
          </div> -->
          <div
            class="file"
            *ngFor="let paymentFile of files.paymentFiles; let i = index"
          >
            <img src="assets/document-icon-blue.svg" />
            <div class="label">
              {{ paymentFile.name }}
            </div>
            <div class="delete-icon">
              <img
                src="assets/cross-in-circle-red-small.svg"
                tabindex="0"
                role="button"
                enterPress="removeFile(paymentFile, 'payment', i)"
                (keydown.enter)="removeFile(paymentFile, 'payment', i)"
                (click)="removeFile(paymentFile, 'payment', i)"
                *ngIf="itemCounter === 1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="left-column">
      <div class="project-row">
        <div id="project" class="field disabled">
          <div class="label">{{ 'ADD_COST.PROJECT' | translate }} *</div>
          <div class="dropdown">
            <div class="value">{{ selectedProject?.name }}</div>
          </div>
        </div>
        <div id="department" class="field" [class.disabled]="isDepartmentFixed">
          <div class="label">{{ 'ADD_COST.DEPARTMENT' | translate }} *</div>
          <!-- TODO: refactor this conditional? -->
          <div
            class="dropdown"
            tabindex="0"
            role="button"
            enterPress="openModal('department-dropdown')"
            (keydown.enter)="openModal('department-dropdown')"
            (click)="openModal('department-dropdown')"
            *ngIf="!isDepartmentFixed"
          >
            <div class="value">{{ selectedDepartment?.name | translate }}</div>
            <img src="assets/arrow-down-purple.svg" class="arrow" />
          </div>
          <div class="dropdown" *ngIf="isDepartmentFixed">
            <div class="value">{{ selectedDepartment?.name | translate }}</div>
          </div>
          <ops-dropdown
            id="department-dropdown"
            parentId="department"
            [optionSpacing]="10"
            [options]="departmentOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            [indent]="10"
            (valueSelected)="onSelectDepartment($event)"
            class="dropdown-component"
          ></ops-dropdown>
        </div>
        <div id="position" class="field position-field">
          <div class="label">
            {{ 'ADD_COST.POSITION' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <div
            class="dropdown"
            tabindex="0"
            role="button"
            autofocus
            enterPress="this.selectedDepartment?.name && openModal('position-dropdown')"
            (keydown.enter)="
              this.selectedDepartment?.name && openModal('position-dropdown')
            "
            (click)="
              this.selectedDepartment?.name && openModal('position-dropdown')
            "
          >
            <input
              focusSelect
              class="input-h-fix"
              value="{{ searchPosition | translate }}"
              (input)="onTypeSearch($event)"
              (focusout)="onCustomPosition()"
              [disabled]="!this.selectedDepartment?.name"
            />
            <img src="assets/arrow-down-purple.svg" class="arrow" />
          </div>
          <ops-dropdown
            id="position-dropdown"
            parentId="position"
            [optionSpacing]="10"
            [options]="positionOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            [indent]="10"
            (valueSelected)="onSelectPosition($event)"
            class="dropdown-component"
          ></ops-dropdown>
        </div>
        <div class="field-row">
          <div class="field">
            <div class="label">
              {{ 'ADD_COST.VENDOR_NAME' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
                >*</span
              >
            </div>
            <input
              class="field"
              tabindex="0"
              (keydown)="onInputName($event)"
              (focusout)="saveName($event)"
              [(ngModel)]="item.name"
            />
          </div>
          <div id="{{ 'payment-date-parent' + id }}" class="field">
            <div class="label">{{ 'ADD_COST.DESCRIPTION' | translate }}</div>
            <input
              tabindex="0"
              class="field"
              (keydown)="onInputDescription($event)"
              (focusout)="saveDescription($event)"
              [(ngModel)]="item.description"
            />
          </div>
        </div>
        <div class="field-row">
          <div id="{{ 'bill-date-parent' + id }}" class="field">
            <!-- {{(!files?.invoiceFiles?.length && !files?.paymentFiles?.length) ? '*' : ''}} -->
            <ops-calendar
              label="{{ 'ADD_COST.DATE_OF_BILL' | translate }} *"
              (dateChanged)="onSelectBillDate($event)"
              formName="item.dateOfBill"
              [date]="item.dateOfBill"
            ></ops-calendar>
          </div>
          <div id="{{ 'payment-date-parent' + id }}" class="field">
            <ops-calendar
              label="{{ 'ADD_COST.PAYMENT_DATE' | translate }} *"
              (dateChanged)="onSelectPaymentDate($event)"
              formName="item.paymentDate"
              [date]="item.paymentDate"
            ></ops-calendar>
          </div>
        </div>
      </div>
      <div class="cost-row">
        <div class="inside-row">
          <div id="currency" class="currency">
            <div class="label">
              {{ 'ADD_COST.CURRENCY' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
                >*</span
              >
            </div>
            <div
              class="dropdown"
              tabindex="0"
              role="button"
              enterPress="openModal('project-currency-dropdown')"
              (keydown.enter)="openModal('project-currency-dropdown')"
              (click)="openModal('project-currency-dropdown')"
            >
              <div class="value">{{ item.currencyCode }}</div>
              <img src="assets/arrow-down-purple.svg" class="arrow" />
            </div>
            <ops-dropdown
              id="project-currency-dropdown"
              parentId="currency"
              [optionSpacing]="10"
              [ignoreSort]="'true'"
              [options]="currencyOptions"
              [isMultiSelect]="false"
              [startingFocusIndex]="0"
              [indent]="10"
              (valueSelected)="onSelectCurrency($event)"
              class="dropdown-component"
            ></ops-dropdown>
          </div>
          <div class="cost">
            <div class="label">
              {{ 'ADD_COST.COST' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
                >*</span
              >
            </div>
            <input
              tabindex="0"
              value="{{ item.cost }}"
              opsNumber
              (input)="onInputCost($event)"
            />
          </div>
          <div class="tax">
            <div class="check-item" (click)="onToggleTax()">
              <div class="checkbox">
                <img
                  *ngIf="hasTax"
                  src="assets/checkmark-square-white-in-purple2.svg"
                />
              </div>
              <div class="label">{{ 'ADD_COST.TAX' | translate }}</div>
            </div>
            <div class="tax-input" [class.disabled]="!hasTax">
              <input
                tabindex="0"
                [disabled]="!hasTax"
                value="{{ item.taxPercentage }}"
                (change)="triggerValidation()"
                (keyup)="onEditTax($event)"
                opsNumber
              />
              %&nbsp;
            </div>
          </div>
        </div>
        <div class="inside-row">
          <div class="currency">
            <div class="label">
              {{ 'ADD_COST.EXCHANGE_RATE' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
              >
                *</span
              >
            </div>
            <div class="input-with-button">
              <ops-numeric-input
                class="exchange-rate-input"
                [value]="item?.exchangeRate ?? 0"
                [decimal]="4"
                (onValueChange)="onEditExchangeRate($event)"
              ></ops-numeric-input>
              <button
                class="reciprocal-btn"
                type="button"
                (click)="calculateReciprocal()"
                [disabled]="!item?.exchangeRate || item.exchangeRate === 0"
              >
                1/x
              </button>
            </div>
            <!-- <input
              value="{{ exchangeRate }}"
              (keyup)="onEditExchangeRate($event)"
              opsNumber
            /> -->
          </div>
          <div class="cost">
            <div class="label">{{ 'ADD_COST.COST_INCL_TAX' | translate }}</div>
            <div class="field">
              {{ currencySymbol }} {{ costIncTax | number : '.0-2' }}
            </div>
            <div class="field-converted" *ngIf="hasDifferentCurrency">
              {{ currencyExchangeSymbol }}
              {{ costIncTaxExchange | number : '.0-2' }}
            </div>
          </div>
          <div class="tax">
            <div class="label">{{ 'ADD_COST.TAX_AMOUNT' | translate }}</div>
            <div class="value">
              {{ currencySymbol }} {{ taxAmount | number : '.0-2' }}
            </div>
            <div class="value-converted" *ngIf="hasDifferentCurrency">
              {{ currencyExchangeSymbol }}
              {{ taxAmountExchange | number : '.0-2' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-column">
      <div class="type-row">
        <div class="counter">
          <div
            class="control"
            tabindex="0"
            role="button"
            enterPress="onCounterDown()"
            (keydown.enter)="onCounterDown()"
            (click)="onCounterDown()"
          >
            -
          </div>
          <div class="value">
            {{ itemCounter }}
          </div>
          <div
            class="control"
            tabindex="0"
            role="button"
            enterPress="onCounterUp()"
            (keydown.enter)="onCounterUp()"
            (click)="onCounterUp()"
          >
            +
          </div>
        </div>
        <div id="cost-type" class="field">
          <div class="label">
            {{ 'ADD_COST.COST_TYPE' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <div
            class="dropdown"
            tabindex="0"
            role="button"
            enterPress="openModal('cost-type-dropdown')"
            (keydown.enter)="openModal('cost-type-dropdown')"
            (click)="openModal('cost-type-dropdown')"
          >
            <div class="value">{{ item.costType | translate }}</div>
            <img src="assets/arrow-down-purple.svg" class="arrow" />
          </div>
          <ops-dropdown
            id="cost-type-dropdown"
            parentId="cost-type"
            [optionSpacing]="10"
            [ignoreSort]="'true'"
            [options]="costTypeOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            [indent]="10"
            (valueSelected)="onSelectCostType($event)"
            class="dropdown-component"
          ></ops-dropdown>
        </div>
        <div id="payment-method" class="field">
          <div class="label">
            {{ 'ADD_COST.METHOD_OF_PAYMENT' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <div
            class="dropdown"
            tabindex="0"
            role="button"
            enterPress="openModal('payment-method-dropdown')"
            (keydown.enter)="openModal('payment-method-dropdown')"
            (click)="openModal('payment-method-dropdown')"
          >
            <div class="value">{{ item.paymentMethod | translate }}</div>
            <img src="assets/arrow-down-purple.svg" class="arrow" />
          </div>
          <ops-dropdown
            id="payment-method-dropdown"
            parentId="payment-method"
            [optionSpacing]="10"
            [options]="paymentMethodOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            [indent]="10"
            (valueSelected)="onSelectPaymentMethod($event)"
            class="dropdown-component"
          ></ops-dropdown>
        </div>
        <div id="paid-by" class="field" [class.disabled]="!item.paymentMethod">
          <div class="label">
            {{ 'ADD_COST.PAID_BY' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <div
            class="dropdown"
            tabindex="0"
            role="button"
            enterPress="()=>{item.paymentMethod && openModal('paid-by-dropdown')}"
            (keydown.enter)="
              item.paymentMethod && openModal('paid-by-dropdown')
            "
            (click)="item.paymentMethod && openModal('paid-by-dropdown')"
          >
            <div class="value">{{ item.paidBy }}</div>
            <img src="assets/arrow-down-purple.svg" class="arrow" />
          </div>
          <ops-dropdown
            id="paid-by-dropdown"
            parentId="paid-by"
            optionSpacing="10"
            [options]="paidByOptions"
            [isMultiSelect]="false"
            [ignoreSort]="'true'"
            [startingFocusIndex]="0"
            [addNewOption]="showAddNewOption"
            [indent]="10" 
            (valueSelected)="onSelectpaidBy($event)"
            class="dropdown-component"
          ></ops-dropdown>
          <!-- [class.disabled]="!paidByOptions?.length" -->
        </div>
        <div id="cost-status" class="field">
          <div class="label">
            {{ 'ADD_COST.COST_STATUS' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <div
            class="dropdown"
            tabindex="0"
            role="button"
            enterPress="openModal('cost-status-dropdown')"
            (keydown.enter)="openModal('cost-status-dropdown')"
            (click)="openModal('cost-status-dropdown')"
          >
            <div class="value">{{ item.costStatus | translate }}</div>
            <img src="assets/arrow-down-purple.svg" class="arrow" />
          </div>
          <ops-dropdown
            id="cost-status-dropdown"
            parentId="cost-status"
            optionSpacing="10"
            [options]="costStatusOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            [indent]="10"
            (valueSelected)="onSelectCostStatus($event)"
            class="dropdown-component"
          ></ops-dropdown>
        </div>
      </div>

      <div id="assign" class="field">
        <div class="label">{{ 'ADD_COST.ASSIGN_TO' | translate }}</div>
        <div
          class="dropdown"
          tabindex="0"
          role="button"
          enterPress="openModal('assign-dropdown')"
          (keydown.enter)="openModal('assign-dropdown')"
          (click)="openModal('assign-dropdown')"
        >
          <div class="value">{{ item.assignedTo }}</div>
          <img src="assets/arrow-down-purple.svg" class="arrow" />
        </div>
        <ops-dropdown
          id="assign-dropdown"
          parentId="assign"
          optionSpacing="10"
          [options]="assignToOptions"
          [isMultiSelect]="false"
          [startingFocusIndex]="0"
          [indent]="10"
          (valueSelected)="onSelectAssignTo($event)"
          class="dropdown-component"
        ></ops-dropdown>
      </div>

      <div
        class="check-item clickable"
        tabindex="0"
        role="button"
        enterPress="onToggleReminder()"
        (keydown.enter)="onToggleReminder()"
        (click)="onToggleReminder()"
      >
        <div class="checkbox">
          <img
            *ngIf="item.hasReminder"
            src="assets/checkmark-square-white-in-purple2.svg"
          />
        </div>
        <div class="label">{{ 'ADD_COST.PAYMENT_REMINDER' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="file-section" [class.disabled]="itemCounter > 1">
      <div class="section-content">
        <div class="bills-clmn column">
          <div class="file-header">
            <input
              hidden
              type="file"
              multiple
              accept=".pdf, .jpg, .jpeg, .heic, .png"
              #uploaderInvoice
              (change)="attachFiles($event, 'invoice')"
            />
            <div class="add-btn">
              <img
                src="assets/plus-in-circle-purple.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderInvoice.click()"
                (keydown.enter)="uploaderInvoice.click()"
                (click)="uploaderInvoice.click()"
                *ngIf="files.invoiceFiles.length < 3 && itemCounter === 1"
              />
            </div>
            <div class="label">
              {{ 'ADD_COST.BILLS' | translate }}
              {{ files.invoiceFiles.length }}/3
            </div>
          </div>
          <!-- <div class="take-a-photo" *ngIf="files.invoiceFiles.length < 3">
            <img
              src="assets/camera-plus.svg"
              tabindex="0"
              role="button"
              enterPress="uploaderInvoice.click()"
              (keydown.enter)="uploaderInvoice.click()"
              (click)="uploaderInvoice.click()"
              *ngIf="files.invoiceFiles.length < 3 && itemCounter === 1"
            />
            <label for="takePhotoInvoice" class="custom-button"
              >Take a Photo</label
            >
            <input
              id="takePhotoInvoice"
              type="file"
              accept="image/*"
              capture="environment"
              hidden
              (change)="onPhotoInvoice($event)"
            />
          </div> -->
          <div
            class="file"
            *ngFor="let invoiceFile of files.invoiceFiles; let i = index"
          >
            <img src="assets/document-icon-blue.svg" />
            <div class="label">
              {{ invoiceFile.name }}
            </div>
            <div class="delete-icon">
              <img
                src="assets/cross-in-circle-red-small.svg"
                tabindex="0"
                role="button"
                enterPress="removeFile(invoiceFile, 'invoice', i)"
                (keydown.enter)="removeFile(invoiceFile, 'invoice', i)"
                (click)="removeFile(invoiceFile, 'invoice', i)"
                *ngIf="itemCounter === 1"
              />
            </div>
          </div>
        </div>
        <div class="payment-clmn column">
          <div class="file-header">
            <input
              hidden
              type="file"
              multiple
              accept=".pdf, .jpg, .jpeg, .heic, .png"
              #uploaderPayment
              (change)="attachFiles($event, 'payment')"
            />
            <div class="add-btn">
              <img
                src="assets/plus-in-circle-purple.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderPayment.click()"
                (keydown.enter)="uploaderPayment.click()"
                (click)="uploaderPayment.click()"
                *ngIf="files.paymentFiles.length < 3 && itemCounter === 1"
              />
            </div>
            <div class="label">
              {{ 'ADD_COST.PAYMENT_STATEMENT' | translate }}
              {{ files.paymentFiles.length }}/3
            </div>
          </div>
          <!-- <div class="take-a-photo" *ngIf="files.paymentFiles.length < 3">
            <img
              src="assets/camera-plus.svg"
              tabindex="0"
              role="button"
              enterPress="uploaderInvoice.click()"
              (keydown.enter)="uploaderInvoice.click()"
              (click)="uploaderInvoice.click()"
              *ngIf="files.paymentFiles.length < 3 && itemCounter === 1"
            />
            <label for="takePhoto" class="custom-button">Take a Photo</label>
            <input
              id="takePhoto"
              type="file"
              accept="image/*"
              capture="environment"
              hidden
              (change)="onPhotoPayment($event)"
            />
          </div> -->
          <div
            class="file"
            *ngFor="let paymentFile of files.paymentFiles; let i = index"
          >
            <img src="assets/document-icon-blue.svg" />
            <div class="label">
              {{ paymentFile.name }}
            </div>
            <div class="delete-icon">
              <img
                src="assets/cross-in-circle-red-small.svg"
                tabindex="0"
                role="button"
                enterPress="removeFile(paymentFile, 'payment', i)"
                (keydown.enter)="removeFile(paymentFile, 'payment', i)"
                (click)="removeFile(paymentFile, 'payment', i)"
                *ngIf="itemCounter === 1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-section">
      <button
        class="cancel button"
        tabindex="0"
        role="button"
        enterPress="close()"
        (keydown.enter)="close()"
        (click)="close()"
      >
        {{ 'ADD_COST.CANCEL' | translate }}
      </button>
      <button
        class="save button"
        (click)="onSave()"
        tabindex="0"
        role="button"
        enterPress="onSave()"
        (keydown.enter)="onSave()"
        [disabled]="!isValid"
        [class.disabled]="!isValid"
      >
        {{ 'ADD_COST.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
</div>
</ng-container>

<!-- Modal components for creating bank accounts and credit cards -->
<ops-bank-account-create-modal
  id="bank-account-create-modal-add-cost"
  (bankAccountCreated)="onBankAccountCreated()"
></ops-bank-account-create-modal>

<ops-credit-card-create-modal
  id="credit-card-create-modal-add-cost"
  (creditCardCreated)="onCreditCardCreated()"
></ops-credit-card-create-modal>

<!-- Custom Currency Modal -->
<ops-custom-currency-modal
  [isVisible]="showCustomCurrencyForm"
  [config]="customCurrencyConfig"
  (currencyAdded)="onCustomCurrencyAdded($event)"
  (modalClosed)="onCustomCurrencyModalClosed()"
></ops-custom-currency-modal>

